import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { User } from '../models/user.model';
import { SidebarService } from '../services/side-bar.service';
import { TaskBarService } from '../services/task-bar.service';
import { FabMessageService } from '../services/fab-message.service';
import { NavigationEnd, Router } from '@angular/router';
import 'rxjs/add/operator/filter';
import { HeaderService } from '../services/header.service';
import { MobileMenuService } from '../services/mobile-menu.service';
import { NotificationsService } from '../services/notifications.service';
import { OperatingStandardComponent } from '../content-page/operating-standard/operating-standard.component';
import { UserConfirmStandardComponent } from '../content-page/operating-standard/user-confirm-standard/user-confirm-standard.component';
import { UserFamiliarizeStandardComponent } from '../content-page/operating-standard/user-familiarize-standard/user-familiarize-standard.component';
import { AdminService } from '../services/admin.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportDatepickerComponent } from '../modals/report-datepicker.component';
import { ReportType } from '../models/report-type.model';
import { HttpStatus } from '../shared.constants/all-constants';
import { HttpResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { GroupResponse } from 'app/services/admin.service.types';

const FAB_SUCCESS = 1;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  public user: User;
  public showSideTasks = true;
  mainGroup;
  isAdmin = false;
  isUser = false;
	isHead = false;
  isHeadOfGroup = false;
  isStorekeeper = false;
  group;
  current;
  planned;
  allHeadGroups: GroupResponse[] = [];
  private groupOptionsSubscription: Subscription;
  mobWidth: any;

  constructor(public authService: AuthService,
    private modalService: NgbModal,
    private adminService: AdminService,
    public userService: UserService,
    public sidebarService: SidebarService,
    public operatingStandardComponent: OperatingStandardComponent,
    public taskbarService: TaskBarService,
    public mobileMenuService: MobileMenuService,
    public fabService: FabMessageService,
    public notificationsService: NotificationsService,
    public headerService: HeaderService,
    private userConfirmStandardComponent: UserConfirmStandardComponent,
    private userFamiliarizeStandardComponent: UserFamiliarizeStandardComponent,
    private router: Router) {


    this.syncStoredShellState();

    this.router.events.filter(event => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects || event.url;
        if (this.isCalendarRoute(url)) {
          this.applyCalendarRouteState();
        } else if (url === '/dashboard/home' || url === '/dashboard') {
          this.showSideTasks = false;
          this.taskbarService.closeTaskBar();
          this.sidebarService.setSelectedMenuOption('home');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else {
          this.showSideTasks = true;
          this.taskbarService.setTaskBar((localStorage.getItem('TaskBar') === 'true'));
        }

        if (url.indexOf('/dashboard/company-structure-user') === 0) {
          this.setCompanyStructureSelection(url);
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(true);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/operating-standard') {
          this.sidebarService.setSelectedMenuOption('op-stands');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/my-created-standards') {
          this.sidebarService.setSelectedMenuOption('my-created-standards');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/standards') {
          this.sidebarService.setSelectedMenuOption('m-stands');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        } else if (url === '/dashboard/standards') {
          this.sidebarService.setSelectedMenuOption('m-standss');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        }
        else if (url === '/dashboard/admin/all-standards-head-only') {
          this.sidebarService.setSelectedMenuOption('m-stands-sho');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        } else if (url === '/dashboard/report') {
          this.sidebarService.setSelectedMenuOption('m-report');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/company-structure') {
          this.sidebarService.setSelectedMenuOption('comp-str');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/admin/users') {
          this.sidebarService.setSelectedMenuOption('users');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(true);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/admin/register-user') {
          this.sidebarService.setSelectedMenuOption('register-user');
          this.sidebarService.setSelectedGroupOptionControll(true);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/admin/create-group') {
          this.sidebarService.setSelectedMenuOption('crt-division');
          this.sidebarService.setSelectedGroupOptionControll(true);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/admin/create-position') {
          this.sidebarService.setSelectedMenuOption('add-pos');
          this.sidebarService.setSelectedGroupOptionControll(true);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/admin/create-schedule') {
          this.sidebarService.setSelectedMenuOption('add-sched');
          this.sidebarService.setSelectedGroupOptionControll(true);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);

        } else if (url === '/dashboard/admin/create-standard') {
          this.sidebarService.setSelectedMenuOption('create-stnd');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(true);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/admin/all-standards') {
          this.sidebarService.setSelectedMenuOption('all-stnd');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(true);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
         } else if (url === '/dashboard/admin/standards-management-admin') {
          this.sidebarService.setSelectedMenuOption('all-stnd-ad');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(true);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/admin/all-standards-head') {
          this.sidebarService.setSelectedMenuOption('all-stnds');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        } else if (url === '/dashboard/create-operating-standard') {
          this.sidebarService.setSelectedMenuOption('create-opstnd');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        } else if (url === '/dashboard/operating-standards') {
          this.sidebarService.setSelectedMenuOption('all-opstnd');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        } else if (url === '/dashboard/standards-management') {
          this.sidebarService.setSelectedMenuOption('std-mngmnt');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
          this.sidebarService.setSelectedStandardsManagement(true);


          // SUGGESTION LISTS
        } else if (url === '/dashboard/create-suggestion-list') {
          this.sidebarService.setSelectedMenuOption('create-sl');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(true);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url.indexOf('/dashboard/my-suggestion-lists') === 0) {
          this.sidebarService.setSelectedMenuOption('my-sl');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/my-suggestion-list') {
          this.sidebarService.setSelectedMenuOption('my-sl-m');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/all-suggestion-lists') {
          this.sidebarService.setSelectedMenuOption('all-sl');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(true);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (url === '/dashboard/for-review-suggestion-lists') {
          this.sidebarService.setSelectedMenuOption('for-review-sl');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(true);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        }

        // Specializations
        else if (url === '/dashboard/specializations-list') {
          this.sidebarService.setSelectedMenuOption('spec-list');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        }

        // Learning
        else if (url === '/dashboard/learning') {
          this.sidebarService.setSelectedMenuOption('learning');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        }
        else if (url === '/dashboard/admin/ai-statistics') {
          this.sidebarService.setSelectedMenuOption('ai-statistics');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        }

        else if (url === '/dashboard/general-settings') {
          this.sidebarService.setSelectedMenuOption('learniy');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        }

        else if (this.isCalendarRoute(url)) {
          this.applyCalendarRouteState();
        } else if (
          url === '/dashboard/admin/clothing'
          || url === '/dashboard/admin/clothing/assignments'
          || url === '/dashboard/admin/clothing/report'
        ) {
          this.sidebarService.setSelectedMenuOption('clothing-settings');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        }

        this.closeMobileMenus();
      });

  }

  @Output() featureSelected = new EventEmitter<string>();

  ngOnInit() {

    this.getList(JSON.parse(localStorage.getItem('User')).mainGroup);

    this.mainGroup = JSON.parse(localStorage.getItem('User')).mainGroup;

    this.user = this.userService.getLocal();

    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
      this.getAllGroups();
    } else {
      this.isHead = false;
    }
    if (this.user.roles.indexOf('ROLE_USER') !== -1) {
      this.isUser = true;
    } else {
      this.isUser = false;
    }
    this.isStorekeeper = this.hasStorekeeperRole();

   
    if (this.isCalendarRoute(this.router.url)) {
      this.applyCalendarRouteState();
    } else if (this.router.url === '/dashboard' || this.router.url === '/dashboard/home') {
      this.showSideTasks = false;
      this.taskbarService.closeTaskBar();
      this.sidebarService.setSelectedMenuOption('home');
      this.sidebarService.setSelectedGroupOptionControll(false);
      this.sidebarService.setSelectedGroupOptionStandards(false);
    }
    this.syncStoredShellState();
  }

  getShift() {
    this.adminService.getsUsersShift().subscribe(
      (response: any) => {
        let a = response.body;
      if (a.current) {
        this.current = a.current;
      }
      if(a.planned) {
          this.planned = a.planned;
      }
    },
    (error: any) => {
  
      }
    )
  }


  open(id) {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_VACATION;
		modalRef.componentInstance.userId = id;
	  }

  getList(a) {
		this.adminService.getGroupByID(a).subscribe(
			(response: any) => {
					this.group = response.body;
          this.getShift();
					if (this.group.head != null) {
						if (this.group.head.id === JSON.parse(localStorage.getItem('User')).id) {
							this.isHeadOfGroup = true;
						}
					}
			},
		);
	}


  signOut() {
    this.authService.signOut();
  }

  onSidebar() {
    this.closeLegacyAccountMenu();
    this.mobileMenuService.toggleSidebar();
  }

  onMobileAccountMenu() {
    this.closeLegacyAccountMenu();
    this.mobileMenuService.toggleAccountMenu();
    if (this.mobileMenuService.isAccountMenuOpen) {
      this.headerService.workTime.startOrRefresh();
      this.getAllGroups();
    }
  }

  closeMobileMenus() {
    this.closeLegacyAccountMenu();
    this.mobileMenuService.closeAll();
  }

  openMobileStorekeeperEmployees() {
    this.sidebarService.setSelectedMenuOption('storekeeper-employees');
    this.mobileMenuService.closeAll();
    this.router.navigate(['/dashboard/company-structure-user'], {
      queryParams: { tab: 'employees' }
    });
  }

  openMobileVacationMenu() {
    this.open(this.isStorekeeper && this.user ? this.user.id : undefined);
    this.closeMobileMenus();
  }

  private closeMobileSidebarByDefault(): void {
    if (window.innerWidth > 1023) {
      return;
    }
    this.sidebarService.setSideBar(false);
  }

  private syncStoredShellState(): void {
    this.sidebarService.setSideBar(localStorage.getItem('NavBar') === 'true');
    if (this.isCalendarRoute(this.router.url)) {
      this.taskbarService.closeTaskBar();
    } else {
      this.taskbarService.setTaskBar(localStorage.getItem('TaskBar') === 'true');
    }
    this.closeMobileSidebarByDefault();
  }

  private closeLegacyAccountMenu(): void {
    const accountMenu = document.getElementById('navbarNavDropdown');
    if (!accountMenu) {
      return;
    }
    accountMenu.classList.remove('show');
    accountMenu.classList.remove('collapsing');
    accountMenu.classList.add('collapse');
    accountMenu.removeAttribute('style');
  }

  private setCompanyStructureSelection(url: string): void {
    if (url.indexOf('tab=employees') !== -1) {
      this.sidebarService.setSelectedMenuOption('storekeeper-employees');
      return;
    }
    this.sidebarService.setSelectedMenuOption('m-groups');
  }

  private applyCalendarRouteState(): void {
    this.showSideTasks = false;
    this.taskbarService.closeTaskBar();
    this.sidebarService.setSelectedMenuOption('learnit');
    this.sidebarService.setSelectedGroupOptionControll(false);
    this.sidebarService.setSelectedGroupOptionStandards(false);
    this.sidebarService.setSelectedSL(false);
    this.sidebarService.setSelectedGroupOptionOpStandards(false);
  }

  private isCalendarRoute(url: string): boolean {
    return url === '/dashboard/calendar'
      || url.indexOf('/dashboard/calendar?') === 0
      || url.indexOf('/dashboard/calendar#') === 0;
  }

  onTaskbar() {
    if (!this.userService.getLocal().testing) {
      this.closeLegacyAccountMenu();
      this.mobileMenuService.toggleTaskbar();
    }
  }

  private hasStorekeeperRole(): boolean {
    if (!this.user || !this.user.roles) {
      return false;
    }
    if (this.user.roles.indexOf('ROLE_STOREKEEPER') !== -1) {
      return true;
    }
    return this.user.roles.indexOf('STOREKEEPER') !== -1;
  }

  isTesting() {
    return this.userService.getLocal().testing;
  }

  recordSignOutTime() {
    this.headerService.workTime.finishWorkDay().subscribe(
      () => this.fabService.showFab(FAB_SUCCESS),
      () => undefined
    );
  }

  disableLogout(): boolean {
    return this.userService.getLocal().testing;
  }

  get finishWorkDisabled(): boolean {
    return this.disableLogout() || !this.headerService.workTime.canFinishWorkDay();
  }

  onNotifyHeader() {
    if (this.userService.getLocal() !== null) {
      if (!this.userService.getLocal().testing) {
        const notify = this.notificationsService.getNearNotification();
        this.operatingStandardComponent.openNotification(notify);
      }
    }
  }

  getAllGroups(): void {
    this.cancelGroupOptions();
    this.allHeadGroups = [];
    if (!this.isHead) {
      return;
    }
    this.groupOptionsSubscription = this.adminService.getGroupsAndPositionsHead().subscribe(
      (res: HttpResponse<Object>) => {
        if (res.status === HttpStatus.OK && Array.isArray(res.body)) {
          this.allHeadGroups = res.body as GroupResponse[];
        }
      },
      () => this.allHeadGroups = []
    );
  }

  ngOnDestroy(): void {
    this.cancelGroupOptions();
  }

  private cancelGroupOptions(): void {
    if (this.groupOptionsSubscription) {
      this.groupOptionsSubscription.unsubscribe();
    }
  }
}








// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/header/header.component.ts